<template>
    <!-- Reassign Order Modal -->
    <div class="modal fade" id="openReassignModal" tabindex="-1" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-lg">
            <div class="modal-content bg-white">
                <div class="modal-header">
                    <h5 class="modal-title">Task Reassign To</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <form class="row g-3">
                        <div class="col-md-4">
                            <label for="customer_name" class="form-label">Client Name</label>
                            <input
                                type="text"
                                class="form-control disabled"
                                id="customer_name"
                                disabled
                                v-model="updateOrderData.order.full_name"
                            />
                        </div>
                        <div class="col-md-4">
                            <label for="order_id" class="form-label">Order ID</label>
                            <input
                                type="text"
                                class="form-control disabled"
                                id="order_id"
                                disabled
                                v-model="updateOrderData.order.order_number"
                            />
                        </div>
                        <div class="col-md-4">
                            <label for="phone_number" class="form-label">Mobile Number</label>
                            <input
                                type="text"
                                class="form-control disabled"
                                id="phone_number"
                                disabled
                                v-model="updateOrderData.order.phone_number"
                            />
                        </div>
                        <div class="col-md-4">
                            <label for="email" class="form-label">Email</label>
                            <input
                                type="text"
                                class="form-control disabled"
                                id="email"
                                disabled
                                v-model="updateOrderData.order.email"
                            />
                        </div>
                        <div class="col-md-8">
                            <label for="email" class="form-label">Address</label>
                            <textarea
                                class="form-control disabled"
                                id="email"
                                rows="1"
                                disabled
                                v-model="updateOrderData.order.booking_address"
                            ></textarea>
                        </div>
                        <hr />
                        <div class="col-md-6">
                            <label for="assign_date" class="form-label">Assign Date <span class="text-danger">*</span></label>
                            <BookingDatePicker
                                v-model="updateOrderData.order_booking_date"
                                :format="'dd-MM-yyyy'"
                                :time-picker="false"
                            />
                        </div>
                        <div class="col-md-6">
                            <label for="assign_date" class="form-label">Assign Time <span class="text-danger">*</span></label>
                            <VueDatePicker
                                v-model="updateOrderData.order_booking_time"
                                time-picker :is-24="false"
                                :clearable="false"
                                :minutes-grid-increment="10"
                                :minutes-increment="15"
                            >
                                <template #input-icon>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clock-11 hm-time-icons"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 9.5 8"/></svg>
                                </template>
                            </VueDatePicker>
                        </div>
                        <div class="col-md-6">
                            <label for="assign_duration" class="form-label">Time Duration (In Hours) <span class="text-danger">*</span></label>
                            <input
                                type="number"
                                class="form-control"
                                id="assign_duration"
                                v-model="updateOrderData.assigned_duration"
                            />
                        </div>
                        <div class="col-md-6">
                            <label for="assign_handyman" class="form-label">Task Assign To <span class="text-danger">*</span></label>
                            <!-- <Select2
                                v-model="updateOrderData.handyman_id"
                                :options="handymanList"
                                required
                                :settings="{
                                    multiple: true,
                                    placeholder: 'Select Handyman',
                                    dropdownCssClass:'assign-handyman-dropdown',
                                    selectionCssClass: 'hm-multiselect'
                                }"
                            /> -->
                            <VueSelect
                                v-model="updateOrderData.handyman_id"
                                :items="handymanList"
                                :multiple="true"
                                :placeholder="'Select Handyman'"
                            ></VueSelect>
                            <small v-if="handymanOptions.length === 0" class="text-danger">Please select valid assign date and time for task.</small>
                        </div>
                        <div class="col-md-12">
                            <label for="description" class="form-label">Comment</label>
                            <textarea
                                class="form-control"
                                id="description"
                                rows="1"
                                v-model="updateOrderData.comment"
                            ></textarea>
                        </div>

                        <div class="col-md-12">
                            <label for="description" class="form-label">Attachment</label>
                            <div class="input-group mb-3">
                                <input
                                    type="file"
                                    class="form-control"
                                    multiple
                                    @change="onFileChange"
                                />
                            </div>

                            <!-- Display image preview -->
                            <img
                                v-for="previewImage in previewOrderImages"
                                :src="previewImage"
                                class="img-thumbnail me-2 mb-2"
                                style="
                                     {
                                        max-height: 150px;
                                        max-width: 150px;
                                    }
                                        "
                                :key="previewImage"
                            />
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <a
                        type="button"
                        class="text-theme pe-3"
                        data-bs-dismiss="modal"
                        v-text="'Cancel'"
                    ></a>
                    <button
                        type="button"
                        class="btn btn-theme btn-sm"
                        v-text="processing ? 'Loading...' : 'Save Task'"
                        @click="assignOrder"
                    ></button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import BookingDatePicker from "./BookingDatePicker";
import Select2 from "vue3-select2-component";
import VueSelect from "./partials/VueSelect";
import { appMixin } from "../mixin/appMixin";

export default {
    name: 'ReassignOrderModal',
    components: {
        Select2,
        BookingDatePicker,
        VueSelect
    },
    mixins: [appMixin],
    data() {
        return {
            processing: false,
            updateOrderData: {
                order: {},
                order_id: "",
                handyman_id: "",
                booking_date: "",
                assigned_duration: "",
                final_amount: 0,
                action: "assign",
                comment: "",
                status: "pending",
                files: [],
                order_booking_date: "",
                order_booking_time: {hours: 9,minutes: 17},
            },
            previewOrderImages: [],
            handymanOptions: [],
            handymanSchedules: [],
            handymanList: []
        }
    },
    props: ['order'],
    created() {
        this.getHandymanUsers();
    },
    mounted() {
        this.$emitter.on('employeeLeaveEvent', (data) => {
            this.openReassignModal(data.order);
        })
    },
    methods: {
        getHandymanUsers() {
            let self = this;
            axios.post("/admin/users/get-handyman-users")
                .then((response) => {
                    self.handymanUsers = response.data.users;

                    // Get id and name of users and push into the userOptions
                    self.handymanOptions = [];
                    response.data.users.forEach((user) => {
                        self.handymanOptions.push({
                            id: user.id,
                            text: user.full_name,
                        });
                    });
                });
        },
        openReassignModal(order) {
            this.updateOrderData.order = order;
            this.updateOrderData.order_id = order.id;
            this.updateOrderData.status = 'assigned';
            this.updateOrderData.action = "reassign";
            this.updateOrderData.booking_date = order.booking_date;
            this.updateOrderData.assigned_duration = order.assigned_order_duration;

            // Display selected handymans
            this.updateOrderData.handyman_id = [];
            // Iterate the order handymans
            order.order_handymans.forEach((element) => {
                this.updateOrderData.handyman_id.push(element.handyman_id);
            });

            // Prepare the order_booking_date and order_booking_time
            this.updateOrderData.order_booking_date = this.dataTimeFormatWithoutUTC(order.booking_date, "YYYY-MM-DD");
            this.updateOrderData.order_booking_time = {hours: this.dataTimeFormatWithoutUTC(order.booking_date, "HH"), minutes: this.dataTimeFormatWithoutUTC(order.booking_date, "mm")};

            // Display the modal
            $('#openReassignModal').modal('show');
        },
        onFileChange(event) {
            for (let file of event.target.files) {
                try {
                    let reader = new FileReader();

                    // Display the image preview
                    reader.onload = (e) => {
                        this.previewOrderImages.push(e.target.result);
                    };
                    reader.readAsDataURL(file); // Not sure if this will work in this context.
                    this.updateOrderData.files.push(file);

                    // Push the images to the quotation image array
                    //this.quotationService.files.push(file);
                } catch {}
            }
        },
        assignOrder() {
            let self = this;
            const config = {
                headers: { "content-type": "multipart/form-data" },
            };

            this.processing = true;

            const data = this.updateOrderData;

            if(this.updateOrderData.handyman_id.length === 0) {
                self.$notification('error', "Please assign at least one handyman to the order.");
                this.isLoading = false;
                return;
            }

            // Get the handyman name
            let names = this.updateOrderData.handyman_id.map((id) => {
                return this.handymanUsers.find(
                    (handyman) => handyman.id == id
                ).name;
            });

            let nameString;
            if (names.length > 2) {
                // Join all but the last name with a comma, and append the last name with "and"
                nameString = `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
            } else if (names.length === 2) {
                // If exactly two names, join with "and"
                nameString = names.join(' and ');
            } else {
                // If only one name, or none, no join needed
                nameString = names.join('');
            }

            // Check if reassign handyman then prepare the comment data
            this.updateOrderData.comment = (this.updateOrderData.comment.length > 0 ? this.updateOrderData.comment + " - " : "") + "(Reassigned to " + nameString + ")";

            axios.post("/admin/orders/assign", this.updateOrderData, config)
                .then((response) => {
                    self.$notification(response.data.status,response.data.message);
                    self.processing = false;
                    // Trigger the event to get the unavailable handymans orders
                    self.$emitter.emit("getUnavailableHandymansOrdersEvent");

                    $('#openReassignModal').modal('hide');
                })
                .catch((error) => {
                    self.processing = false;
                    self.$notification('error', error.response.data.message);
                });
        },
        async getHandymanAvailable() {
            //First check if processing then return
            if (this.processing) return;
            this.processing = true;

            // Prepare start and end time
            let params = {
                order_id: this.updateOrderData.order_id,
                booking_date: this.updateOrderData.order_booking_date,
                start_time: this.updateOrderData.order_booking_time,
                end_time: { 
                    hours: this.padZero(parseInt(this.updateOrderData.order_booking_time.hours) + this.updateOrderData.assigned_duration),
                    minutes: this.updateOrderData.order_booking_time.minutes 
                },
            };
            let users = await this.getHandymanForTaskAssignment(params);

            //Check if user is empty then empty the handyman_ids
            if (users.length == 0) {
                this.updateOrderData.handyman_id = [];
            }
            //Prepare the options
            this.handymanList = users.map(user => ({
                id: user.id,
                text: user.name,
                name: user.name,
            }));

            this.processing = false;
        },
    },
    watch: {
        'updateOrderData.order_booking_date': function(newVal, oldVal) {
            this.updateOrderData.booking_date = this.dataTimeFormatWithoutUTC(this.updateOrderData.order_booking_date, 'YYYY-MM-DD') + ' ' + this.updateOrderData.order_booking_time.hours + ':' + this.updateOrderData.order_booking_time.minutes + ':00';
            this.getHandymanAvailable();
        },
        'updateOrderData.order_booking_time': function(newVal, oldVal) {
            this.updateOrderData.booking_date = this.dataTimeFormatWithoutUTC(this.updateOrderData.order_booking_date, 'YYYY-MM-DD') + ' ' + this.updateOrderData.order_booking_time.hours + ':' + this.updateOrderData.order_booking_time.minutes + ':00';
            this.getHandymanAvailable();
        },
    }
}
</script>
